import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { constants } from 'fs';
import { MasterConstants } from '../../common/constants/master-constants';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;
  appInsightsKey = "";
  constructor() {
    var hostname = window.location.hostname;
    console.log("hostname" + window.location.hostname);
    if (hostname.includes("evolvestage") || hostname.includes("evolveqa1")) {
      this.appInsightsKey = MasterConstants.INSTRUMENTATION_KEYS.SKEY;
    }
    if (hostname.includes("evolvestage2") || hostname.includes("evolveqa2")) {
      this.appInsightsKey = MasterConstants.INSTRUMENTATION_KEYS.S2KEY;
    }
    else if (hostname.includes("evolvedev") || hostname.includes("evolvedv")) {
      this.appInsightsKey = MasterConstants.INSTRUMENTATION_KEYS.DKEY;
    }
    else if (hostname.includes("evolve.winfieldunited.com")) {
      this.appInsightsKey = MasterConstants.INSTRUMENTATION_KEYS.PKEY;
    }
    else if (hostname.includes("localhost")) {
      this.appInsightsKey = "";
    }
    else {
      this.appInsightsKey = MasterConstants.INSTRUMENTATION_KEYS.DKEY;
    }

    if (!this.appInsightsKey) {
      // add custom behavior to handle this scenario
      console.error('Application Insights key not found.');
      return;
    }
    else {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: this.appInsightsKey,
          enableAutoRouteTracking: true, // optional: auto-log all route changes
        },
      });

      this.appInsights.loadAppInsights();

      if (typeof localStorage !== 'undefined') {
        if (localStorage.getItem('evolveAccess') != 'null' && localStorage.getItem('evolveAccess') != null) {
          this.appInsights.context.user.id = JSON.parse(localStorage.evolveAccess).resultData[0].userId;
        }
      }
    }
  }

  // helper methods to track a variety of events and metric
  logPageView(name?: string, url?: string) {
    if (this.appInsightsKey) {
      this.appInsights.trackPageView({
        name: name,
        uri: url,
      });
    }
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (this.appInsightsKey) {
      this.appInsights.trackEvent({ name: name }, properties);
    }
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (this.appInsightsKey) {
      this.appInsights.trackMetric({ name: name, average: average }, properties);
    }
  }

  logException(exception: Error, severityLevel?: number) {
    if (this.appInsightsKey) {
      this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (this.appInsightsKey) {
      this.appInsights.trackTrace({ message: message }, properties);
    }
  }
}
